<p-float-label>
  <p-date-picker
    #calendar
    [showIcon]="true"
    [(ngModel)]="controlValue"
    inputId="weekSelectionId"
    selectionMode="range"
    dateFormat="m/d/y"
    [showClear]="false"
    appendTo="body"
    inputStyleClass="date-Format"
    (onSelect)="onChange()"
    (onblur)="onChange()"
    (onClear)="onChange()"
    (onShow)="onShow()"
    (onClose)="onClose()"
    [touchUI]="layoutService.mobile$ | async"
  >
  </p-date-picker>
  @if (label) {
    <label for="weekSelectionId">{{ label ?? 'Date' }}</label>
  }
</p-float-label>
